import reducer, { initialState } from '../../reducers/phoneFlow';
import * as actions from '../../actions/phoneFlow';


const fn = { reducer, initialState, actions };
export default fn;
 
